"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldAssignee = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _useAxiosSwr = require("../../../../utils/useAxiosSwr");

/* eslint-disable no-eq-null */

/**
 * Variant of FieldSelectAdapator that uses option.label
 * instead of option.value.  This is a special case specifically
 * for the assignee field.
 */
const Adaptor = ({
  input,
  meta,
  ...rest
}) => /*#__PURE__*/React.createElement(_blocks.FieldSelect, (0, _extends2.default)({}, input, rest, {
  value: input.value.value,
  onChange: option => input.onChange(option.label),
  error: meta.touched && meta.error ? meta.error : undefined
}));

const FieldAssignee = ({
  site
}) => {
  var _assigneeData$map;

  const parts = site === null || site === void 0 ? void 0 : site.split('~'); // Skip is defined based on the existence of site, parts should always be
  // defined and this was the logic prior to the change to support hydra.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  const {
    data: assigneeData
  } = (0, _useAxiosSwr.useHashtagUsernameList)(parts[0], parts[1], {
    skip: site === undefined
  });
  return /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
    label: _core.i18n._({
      id: 'action_form.assignee_label',
      message: `Assignee`
    }),
    name: "assignee",
    placeholder: _core.i18n._({
      id: 'action_form.select_placeholder',
      message: `Select...`
    }),
    options: (_assigneeData$map = assigneeData === null || assigneeData === void 0 ? void 0 : assigneeData.map(a => ({
      label: a.display,
      value: a.display
    }))) !== null && _assigneeData$map !== void 0 ? _assigneeData$map : [],
    component: Adaptor,
    menuPosition: "fixed"
  });
};

exports.FieldAssignee = FieldAssignee;